export const convertDate = (startDate, endDate) => {
  const sDate = new Date(startDate)
  const eDate = new Date(endDate)
  const formattedStartDate = `${sDate.getDate()}/${
    sDate.getMonth() + 1
  }/${sDate.getFullYear()}`
  const formattedEndDate = `${eDate.getDate()}/${
    eDate.getMonth() + 1
  }/${eDate.getFullYear()}`
  return `${formattedStartDate} - ${formattedEndDate}`
}
